const backofficeApiUrl = 'https://gcp-test-backoffice-barkyn-56ri.encr.app';
const klaviyoMiddlewareUrl =
  'https://quwq2uksj9.execute-api.eu-west-3.amazonaws.com';

switch (Shopify.country) {
  case 'PT':
    var country = 'Portugal';
    break;
  case 'ES':
    var country = 'Spain';
    break;
  case 'IT':
    var country = 'Italy';
    break;
  default:
    var country = 'Portugal';
    break;
}

/*=========================== CUSTOMERS ==========================*/

const customerCreateMetafield = async (customerID, metafieldObj) => {
  const requestObj = {
    country,
    metafield: metafieldObj,
  };

  const response = await fetch(
    `${backofficeApiUrl}/customers/${customerID}/metafieldsV2`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestObj),
    }
  );
  const data = await response.json();
  return data;
};

/*=========================== DOGS ==========================*/
const getDogs = async (customerID) => {
  const response = await fetch(
    `${backofficeApiUrl}/customers/${customerID}/dogs`
  );
  const { dogs } = await response.json();
  return dogs;
};

const createDog = async (customerID, dogObj) => {
  const response = await fetch(
    `${backofficeApiUrl}/customers/${customerID}/dogs`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dogObj),
    }
  );
  const data = await response.json();
  return data;
};

const updateDog = async (customerID, dogID, dogObj) => {
  const response = await fetch(
    `${backofficeApiUrl}/customers/${customerID}/dogs/${dogID}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dogObj),
    }
  );
  const data = await response.json();
  return data;
};

const getDogMetafields = async (customerID, dogID) => {
  const response = await fetch(
    backofficeApiUrl + `/customers/${customerID}/dogs/${dogID}/metafields`,
    { method: 'POST' }
  );

  const { data } = await response.json();

  return data.metafields;
};

const updateDogMetafields = async (customerID, dogID, metafields) => {
  const metafieldsString = JSON.stringify(metafields);
  const response = await fetch(
    backofficeApiUrl + `/customers/${customerID}/dogs/${dogID}/metafields`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ metafields: metafieldsString, country: country }),
    }
  );

  const data = await response.json();
  return data;
};

/*=========================== KLAVIYO ==========================*/

async function updateKlaviyoDogs(email, dogs) {
  const klaviyoDogs = {};

  dogs.map((dog, index) => {
    for (const [key, value] of Object.entries(dog)) {
      if (key === 'name') {
        klaviyoDogs[`Dog Name ${index + 1}`] = value;
        continue;
      }

      if (key === 'life_stage') {
        klaviyoDogs[`dog${index + 1}_lifestage`] = value;
        continue;
      }

      if (key === 'gender') {
        klaviyoDogs[`dog${index + 1}_gender`] = value
        continue;
      }

      klaviyoDogs[`dog${index + 1}_${key}`] = Array.isArray(value)
        ? value.join(', ')
        : value;
    }
  });

  const url = `${klaviyoMiddlewareUrl}/dev/update-klaviyo-profile/${email}`;

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(klaviyoDogs),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const { data } = await response.json();

  return data;
}

async function createKlaviyoProfile(info) {
  const url = `${klaviyoMiddlewareUrl}/dev/sync-klaviyo-customer-v2`;

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(info),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const { data } = await response.json();

  return data;
}
async function updateKlaviyoProfile(email, info) {
  const url = `${klaviyoMiddlewareUrl}/dev/update-klaviyo-profile/${email}`;

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(info),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const { data } = await response.json();

  return data;
}

/*=========================== VET APPOINTMENTS ==========================*/
async function saveAppointment(data) {
  for (const prop in data) {
    if (prop === 'id_vet' || prop === 'id_customer') {
      data[prop] = parseInt(data[prop]);
    }
  }

  const vetID = data.id_vet;
  const response = await fetch(
    `${backofficeApiUrl}/vets/${vetID}/appointments`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }
  );

  const appointment = await response.json();

  return appointment;
}

async function updateAppointment(data) {
  //loop through all props of data and parse int any prop that is a number
  console.log(data.id);
  for (const prop in data) {
    if (prop === 'id' || prop === 'id_vet' || prop === 'id_customer') {
      data[prop] = parseInt(data[prop]);
    }
  }

  const vetID = data.id_vet;
  const appointmentID = data.id;

  const response = await fetch(
    `${backofficeApiUrl}/vets/${vetID}/appointments/${appointmentID}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }
  );

  const appointment = await response.json();

  return appointment;
}

async function getCustomerAppointments(customerID) {
  const response = await fetch(
    `${backofficeApiUrl}/customers/${customerID}/appointments`
  );

  const { appoinments } = await response.json();

  return appoinments;
}
